var map = {
	"./mirandela/default-logo.png": 57614,
	"./mirandela/favicon.png": 61595,
	"./mirandela/footer-logo.png": 51356,
	"./mirandela/logo-1.svg": 36667,
	"./mirandela/logo-2.svg": 85928,
	"./mirandela/logo-3.svg": 51321,
	"./mirandela/logo-header-mobile.svg": 28268,
	"./mirandela/logo-header-tablet.svg": 32746,
	"./mirandela/logo-header.svg": 31601,
	"./mirandela/logo-mobile.svg": 38332,
	"./mirandela/logo.svg": 87713,
	"./mirandela/maskable-icon.png": 129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38618;